import moment from 'moment-timezone';

import { DATE_DAILY_FORMAT } from '../../constants/date';
import { getRandomRgb } from '../../utils/colors';

const today = moment().format(DATE_DAILY_FORMAT);

const initialState = {
  modalVisible: false,
  id: null,
  title: null,
  color: null,
  description: null,
  duration: [today, today],
};

const update = (state = initialState, action) => {
  switch (action.type) {
    case 'ADD_NEW_LABEL':
      return {
        ...state,
        modalVisible: true,
        color: getRandomRgb(),
        duration: action.duration || [today, today],
      };

    case 'SELECT_LABEL':
      return {
        ...state,
        ...action.label,
        modalVisible: true,
      };

    case 'INPUT_LABEL_TITLE':
      return {
        ...state,
        title: action.title,
      };

    case 'INPUT_LABEL_DESCRIPTION':
      return {
        ...state,
        description: action.description,
      };

    case 'SET_LABEL_DURATION':
      return {
        ...state,
        duration: action.duration,
      };

    case 'DELETE_LABEL':
    case 'UPDATE_LABEL':
    case 'CREATE_LABEL':
    case 'CLOSE_LABELS_MODAL':
    case 'UPDATE_LOCATION':
      return initialState;

    default:
      return state;
  }
};

export default update;

export const isModalVisible = (state) => state.modalVisible;

export const getId = (state) => state.id;

export const getTitle = (state) => state.title;

export const getDescription = (state) => state.description;

export const getDuration = (state) => state.duration;

export const getColor = (state) => state.color;
